import PropTypes from 'prop-types'
import { Container, Box, Typography } from '@mui/material'
import useTranslations from '../../../i18n/useTranslations'

import styles from './styles'

const Error = ({ title, text, image, children }) => {
  const t = useTranslations()

  return (
    <Container maxWidth="lg">
      <Box sx={styles.content}>
        <Box sx={styles.infoContent}>
          <Typography variant="h1" className="mainTitle" sx={styles.title}>
            {t(title)}
          </Typography>
          <Typography variant="body1" sx={styles.text}>
            {t(text)}
          </Typography>
          {children}
        </Box>
        <Box sx={styles.imageWrapper}>{image}</Box>
      </Box>
    </Container>
  )
}

Error.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
}

export default Error
